import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ButtonCloseContact } from "../molecules/ButtonCloseContact";
import { t } from "i18next";
import PreviewRoutine from "@/pages/InformationUserPages/Components/PreviewRoutine";

export type PreviewRoutineDialogProps = {
    visible: boolean;
    onClose: () => void;
    id: number;
    userId: number;
    position?: number | null;
};

export const PreviewRoutineDialog: FC<PreviewRoutineDialogProps> = ({
    visible,
    onClose,
    id,
    userId,
    position = null,
}) => {
    return (
        <Fragment>
            <Dialog open={visible} onClose={onClose} className="relative z-10">
                <div className="fixed inset-0" />
                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-4xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                    <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                                        <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                                            {t("share.views.preview_plan")}
                                        </DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <ButtonCloseContact onClick={onClose} />
                                        </div>
                                    </div>

                                    <div className="flex-1 overflow-y-auto">
                                        <PreviewRoutine
                                            id={id}
                                            user_id={userId}
                                            position={position}
                                        />
                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Fragment>
    );
};
